import { render } from "./Itinerarios.vue?vue&type=template&id=445ffc55&scoped=true"
import script from "./Itinerarios.vue?vue&type=script&lang=js"
export * from "./Itinerarios.vue?vue&type=script&lang=js"

import "./Itinerarios.vue?vue&type=style&index=0&id=445ffc55&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445ffc55"]])

export default __exports__